var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:" text-center",attrs:{"flat":"","tile":""}},[_c('span',{domProps:{"innerHTML":_vm._s(
      _vm.formatNumber({
        num: _vm.Articulo[0].EnTransito,
        univenta: _vm.Articulo[0].UniVenta,
      })
    )}})])}
var staticRenderFns = []

export { render, staticRenderFns }